const numberFormatter = new Intl.NumberFormat('es-ES', { useGrouping: true, maximumFractionDigits: 2 });
export function formatReportNumber(value) { return value !== null && value !== '' && Number.isFinite(Number(value)) ? numberFormatter.format(Number(value)) : '—'; }
export function formatReportPerformance(value) {
  const source = String(value || '').trim();
  // Numeric percentages in Drupal are emitted with either a decimal point or comma.
  if (!/^[+-]?\d+(?:[.,]\d+)?\s*%$/.test(source)) return source;
  return `${formatReportNumber(Number(source.replace('%', '').trim().replace(',', '.')))} %`;
}
